import { AnaColumn } from "../forms-template.service";





export const gestioneUtenti: AnaColumn[] = [
  {

    itemType: "group", colCount: "2", colSpan: "2", class: 'mt-5', groupDataField: 'datiUtente', data: [

      //{ type: 'button', hideOnEdit: true, disableOnUpdate: true, button: { event: "OptionalIconButtonClick", name: "resetPwd", hint: "Reinvia", icon: "revert" } },
      {
        type: 'campo', dataField: "userName", dataType: "", caption: "Username",
        placeHolder: 'esempio@esempio.it', colSpan: '1',
        nCol: 5,
        validation: [{ type: "required", message: 'Il Campo è Obbligatorio' }, { type: 'email', message: 'Il Campo non è in formato Email' }]
      },
      /*{
        type: 'campoSpecial', colSpan: "1",disableOnUpdate: false, dataField: "importaUtente",
        caption: "Importa da Utente",colVisible:false,nCol:5,dataType: "",editorType: 'dxLookup',
        lista: {
          dataSource: 'Account/GetUserByLicenze',
          displayExpr: 'nomeCompleto',
          valueExpr: 'id',
          static: false,
         
          showClearButton:true,
          colonne:[
            {
              dataField:'nomeCompleto',              
              caption:'Ragione Sociale'
            },
            {
              dataField:'userName',              
              caption:'User Name'
            }
          ]
        }
      },*/

      {
        type: 'campoSpecial', dataField: "tipoUtente", dataType: "", caption: "Tipo Utente",
        colSpan: "1",
        nCol: 3,
        lista: {
          static: true,
          caption: 'Tipo Utente',
          dataSource: 'tipoutente',
          valueExpr: 'id',
          displayExpr: 'descrizione',
        },
        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],
        editorType: 'dxSelectBox'
      },

      /*
      { type: 'campo', hideOnEdit: true, disableOnUpdate: true, dataField: "guidAccettazione", dataType: "",
       caption: "Invito", allowFiltering:false },
       */

      // {
      //   disableOnUpdate: false, type: 'campo', dataField: "nomeCompleto", dataType: "", caption: "Nome Completo",
      //   validation: [{ type: "required", message: "Campo Obbligatorio" }], nCol:5,
      // },        
      {
        disableOnUpdate: false, type: 'campo', dataField: "nome", dataType: "", caption: "Nome",
        validation: [{ type: "required", message: "Campo Nome Obbligatorio" }], nCol: 5,
      },
      {
        disableOnUpdate: false, type: 'campo', dataField: "cognome", dataType: "", caption: "Cognome",
        validation: [{ type: "required", message: "Campo Cognome Obbligatorio" }], nCol: 3,
      },


      { disableOnUpdate: false, type: 'campo', dataField: "emailRecupero", dataType: "", caption: "Email Recupero", nCol: 5 },
      {
        disableOnUpdate: false, minLength: '11', maxLength: '16', type: 'campo', dataField: "codiceFiscale", dataType: "", caption: "Codice Fiscale", nCol: 3,
        // validation: [{ type: "required", message: 'Il Campo è Obbligatorio'}]
      },


      { disableOnUpdate: false, type: 'campo', dataField: "emailComunicazioni", dataType: "", caption: "Email Comunicazioni", nCol: 5 },

      {
        type: 'campo', dataField: "telefono", dataType: "", caption: 'Telefono', nCol: 3, colSpan: '1', maxLength: 20

      },

      { type: 'campo', dataField: 'sospeso', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Sospeso' },




      {

        type: 'campoData', dataField: "scadenzaAccount", caption: "Scadenza Account", format: "dd/MM/yyyy", editorType: "dxDateBox", dataType: "date",
        maxLength: '15', nCol: 3, maxSize: 15, colSpan: 2
      },



    ]
  },
  {
    itemType: "group", caption: "Tipo Attività Utente App", colCount: "6", colSpan: '2', class: 'mt-3', groupDataField: 'tipoAttivita', data: [
      {
        type: 'campo', dataField: "firmaRentriProduttore", dataType: "boolean", caption: "Produttore", editorType: "dxCheckBox", colVisible: false,
        colSpan: '1', disabled: false,
      },
      {
        type: 'campo', dataField: "firmaRentriAutista", dataType: "boolean", caption: "Trasportatore", editorType: "dxCheckBox", colVisible: false,
        colSpan: '1', disabled: false,
      },
      {
        type: 'campo', dataField: "firmaRentriSmaltitore", dataType: "boolean", caption: "Destinatario", editorType: "dxCheckBox", colVisible: false,
        colSpan: '1', disabled: false,
      },
      {
        type: 'campo', dataField: "firmaRentriConsulente", dataType: "boolean", caption: "Consulente", editorType: "dxCheckBox", colVisible: false,
        colSpan: '1', disabled: false,
      },
      {
        type: 'campo', dataField: "firmaRentriIntermediario", dataType: "boolean", caption: "Intermediario", editorType: "dxCheckBox", colVisible: false,
        colSpan: '1', disabled: false,
      },
      {
        type: 'campo', dataField: "firmaRentriAssociazione", dataType: "boolean", caption: "Associazione", editorType: "dxCheckBox", colVisible: false,
        colSpan: '1', disabled: false
      },
    ]
  },

]